import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content"];

  initialize(){
    const font = "'Open Sans', system-ui, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif"

    // Meme habillage que chart_controller (design system).
    this.options = {
      cutoutPercentage: 68,
      legend: {
        display: true,
        position: 'bottom',
        align: 'center',
        labels: {
          usePointStyle: true,
          boxWidth: 8,
          padding: 14,
          fontColor: '#4D534F',
          fontFamily: font,
          fontSize: 12,
          fontStyle: '600'
        }
      },
      tooltips: {
        backgroundColor: '#121613',
        titleFontFamily: font,
        bodyFontFamily: font,
        bodyFontSize: 12,
        xPadding: 10,
        yPadding: 8,
        cornerRadius: 8,
        caretSize: 5
      }
    }
  }

  connect() {
    const keys = JSON.parse(this.data.get("keys"));
    const datasets = JSON.parse(this.data.get("datasets"));
    const colors = JSON.parse(this.data.get("colors"));

    new Chart(this.contentTarget, {
      type: 'doughnut',
      data: {
          labels: keys,
          datasets: [{
            label: 'My First Dataset',
            data: datasets,
            backgroundColor: colors,
            borderColor: '#FFFFFF',
            borderWidth: 2,
            hoverBorderColor: '#FFFFFF',
            hoverOffset: 8
          }]
      },
      options: this.options
    });
  }
}
